<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Academic
            </h2>
        </template>

        <breeze-page :submenus="subMenus">
            <slot></slot>
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import BreezePage from "@/Components/Page";

export default {
    components: {
        BreezeAuthenticatedLayout,
        BreezePage,
    },
    data() {
        return {
            subMenus: [
                {
                    title: "Durations",
                    active: route().current("academic.duration.*"),
                    route: "academic.duration.list",
                    visible: this.$page.props.auth.user.role.permissions.find(
                        (permission) =>
                            permission.name === "Create Duration" ||
                            permission.name === "Edit Duration" ||
                            permission.name === "View Duration"
                    ),
                },
                {
                    title: "Semesters",
                    active: route().current("academic.semester.*"),
                    route: "academic.semester.list",
                    visible: this.$page.props.auth.user.role.permissions.find(
                        (permission) =>
                            permission.name === "Create Semester" ||
                            permission.name === "Edit Semester" ||
                            permission.name === "View Semester"
                    ),
                },
                {
                    title: "Duration Semesters",
                    active: route().current("academic.durationSemester.*"),
                    route: "academic.durationSemester.list",
                    visible: this.$page.props.auth.user.role.permissions.find(
                        (permission) =>
                            permission.name === "Create Duration Semester" ||
                            permission.name === "Edit Duration Semester" ||
                            permission.name === "View Duration Semester"
                    ),
                },
                {
                    title: "Course Types",
                    active: route().current("academic.coursetype.*"),
                    route: "academic.coursetype.list",
                    visible: this.$page.props.auth.user.role.permissions.find(
                        (permission) =>
                            permission.name === "Create Course Type" ||
                            permission.name === "Edit Course Type" ||
                            permission.name === "View Course Type"
                    ),
                },
                {
                    title: "Courses",
                    active:
                        route().current("academic.course.list") ||
                        route().current("academic.course.create") ||
                        route().current("academic.course.update"),
                    route: "academic.course.list",
                    visible: this.$page.props.auth.user.role.permissions.find(
                        (permission) =>
                            permission.name === "Create Course" ||
                            permission.name === "Edit Course" ||
                            permission.name === "View Course"
                    ),
                },
                {
                    title: "Subjects",
                    active: route().current("academic.subject.*"),
                    route: "academic.subject.list",
                    visible: this.$page.props.auth.user.role.permissions.find(
                        (permission) =>
                            permission.name === "Create Subject" ||
                            permission.name === "Edit Subject" ||
                            permission.name === "View Subject"
                    ),
                },
                {
                    title: "Course Years",
                    active: route().current("academic.courseyear.*"),
                    route: "academic.courseyear.list",
                    visible: this.$page.props.auth.user.role.permissions.find(
                        (permission) =>
                            permission.name === "Create Course Year" ||
                            permission.name === "Edit Course Year" ||
                            permission.name === "View Course Year"
                    ),
                },
            ],
        };
    },
};
</script>
